"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _styles = require("@mui/styles");

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Buttons = require("../../../Buttons");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    chipRoot: {
      height: 28,
      backgroundColor: palette.secondary.main,
      color: palette.common.white
    },
    chipDeleteIcon: {
      color: palette.common.white,
      width: 16,
      height: 16,
      '&:hover': {
        color: palette.common.white
      }
    },
    chipLabel: {
      paddingTop: 2,
      maxWidth: 200
    },
    totalText: {
      display: 'inline-block',
      fontSize: 16,
      fontWeight: 'bold',
      color: palette.grey.main,
      minWidth: 180
    },
    linkButton: {
      display: 'inline-block',
      fontFamily: 'Lato',
      fontSize: 16,
      color: palette.link.main
    }
  };
});
/**
 * Filter chips.
 *
 * @param {Object} props
 * @param {number} [props.visibleCount=5]
 * @param {function(): void} props.onClearAll
 * @param {Object} [props.overrideClasses = {}]
 * @param {JSX.Element[]} props.children
 * @returns {ReactElement}
 */

var FilterChips = function FilterChips(_ref2) {
  var _ref2$visibleCount = _ref2.visibleCount,
      visibleCount = _ref2$visibleCount === void 0 ? 5 : _ref2$visibleCount,
      onClearAll = _ref2.onClearAll,
      overrideClasses = _ref2.overrideClasses,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? [] : _ref2$children;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showAll = _useState2[0],
      setShowAll = _useState2[1];

  var chips = (0, _react.useMemo)(function () {
    return children.map(function (element) {
      return /*#__PURE__*/(0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, element.props), {}, {
        deleteIcon: /*#__PURE__*/_react["default"].createElement(_Close["default"], {
          "data-id": element.props['data-id']
        }),
        classes: {
          root: (0, _classnames["default"])(classes.chipRoot, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.chipRoot),
          deleteIcon: (0, _classnames["default"])(classes.chipDeleteIcon, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.chipDeleteIcon),
          label: (0, _classnames["default"])(classes.chipLabel, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.chipLabel)
        }
      }));
    });
  }, [children, classes, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.chipRoot, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.chipDeleteIcon, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.chipLabel]);
  var visibleChips = (0, _react.useMemo)(function () {
    return showAll ? chips : (0, _ramda.slice)(0, visibleCount, chips);
  }, [chips, visibleCount, showAll]);
  var moreItemsCount = chips.length > visibleCount ? chips.length - visibleCount : 0;
  var isShowAllVisible = moreItemsCount > 0;
  var showAllButtonText = showAll ? 'Show less' : "Show (".concat(moreItemsCount, ") more");
  var handleShowAll = (0, _react.useCallback)(function () {
    return setShowAll(!showAll);
  }, [showAll]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, visibleChips, isShowAllVisible && /*#__PURE__*/_react["default"].createElement(_Buttons.LinkButton, {
    "data-testid": "FilterChipsShowAllButton",
    className: (0, _classnames["default"])(classes.linkButton, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.linkButton),
    onClick: handleShowAll
  }, showAllButtonText), !!chips.length && /*#__PURE__*/_react["default"].createElement(_Buttons.LinkButton, {
    className: classes.linkButton,
    onClick: onClearAll
  }, "Clear all"));
};

var _default = /*#__PURE__*/(0, _react.memo)(FilterChips);

exports["default"] = _default;